module.exports = __webpack_public_path__ + "static/media/galerija_2022_0018.de129627.jpg";